// from devvratsarkar77@gmail.com

import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getMessaging, isSupported, type Messaging } from "firebase/messaging";

export const firebaseConfig = {
    apiKey: "AIzaSyAR6SbIgKIrsJPqaN3DrYiYjgty7icjrOM",
    authDomain: "vallote-d0ad5.firebaseapp.com",
    projectId: "vallote-d0ad5",
    storageBucket: "vallote-d0ad5.firebasestorage.app",
    messagingSenderId: "286055658790",
    appId: "1:286055658790:web:73981d2032ab66dddafde7",
    measurementId: "G-8VVQ33BHDF"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export async function getFirebaseMessaging(): Promise<Messaging | null> {
    if (typeof window === "undefined") return null;

    const supported = await isSupported();
    if (!supported) return null;

    return getMessaging(app);
}